import React, { useMemo } from "react"
import Label from "components/general/Label";
import { useViewport } from 'components/general/useViewPort'
import MirsTable from "components/general/table/Table"
import Noc from "components/presentation/Noc";
import Competitor from 'components/presentation/Competitor';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const getConfiguration = ({ breakPoint, params }) => {
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    let configuration = {
        columns: [],
        sortBy: [],
        disableSort: false
    };

    configuration.sortBy = [{ id: "Competitor", desc: false }, { id: "NOC", desc: false }];
    configuration.columns = isMobile ? TableColumnsSM({ params }) : TableColumns({ params })
    return configuration;
};


const HorsesTable = ({ data }) => {
    const { breakPoint } = useViewport();
    const params = useUrlFriendlyToParameters();
    const config = useMemo(() => getConfiguration({ breakPoint, params }), [breakPoint, params]);

    return (
        <MirsTable
            className="table-schedule"
            data={data}
            columns={config.columns}
            keyRow='eventUnit-code'
            initialSortBy={config.sortBy}
            id={`mirs-table-horses`}
            showPagination={true}
        // pageSizeCustom={10}
        />
    )
}

export default HorsesTable;


function TableColumns({ params }) {
    return (
        [
            ColumnCompetitor({}),
            ColumnNoc({ params: params, longDesc: true })
        ]
    )
}

function TableColumnsSM({ params }) {
    return (
        [
            ColumnCompetitor({}),
            ColumnNoc({ params, longDesc: false })
        ]
    )
}

export function ColumnNoc({ disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start w-20',
    label = 'HeaderTeamNOC',
    remove = false,
    longDesc = true,
    params = {}
}) {

    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            id: 'NOC',
            accessor: (props) => props?.organisation?.longDescriptionOrder,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            multiSort: [{ id: "NOC" }, { id: 'Competitor', desc: false }],
            Cell: (props) => {
                let data = props.cell.row.original?.organisation
                return (<Noc {...data} showImage={true} showLongDesc={longDesc} hasLink={true} />);
            }
        }
    )

}

export function ColumnCompetitor({
    disableSort = false,
    className = 'schedule-discipline text-start',
    headerClassName = 'text-start',
    label = "LabelName"
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            id: 'Competitor',
            accessor: (props) => props?.name?.toLowerCase(),
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            multiSort: [{ id: "Competitor" }, { id: "Noc", desc: false }],
            Cell: (props) => {
                const row = props.cell.row.original
                return (
                    <Competitor {...row} hideNoc={true} hidePicture={true} key={`participant-${row?.code}`} />
                )
            }
        }
    )
}


